<template>
  <div id="app">
    <div class="loadding" v-if="$store.state.refund.LOADING">
      <van-loading type="spinner" color="#36B374" />
    </div>
    <!-- 对退货系统单独处理缓存，避免影响其他系统 -->
    <template v-if="key.includes('/refund/') || key.includes('/travelAgency/')">
      <keep-alive :include="cachedViews">
        <router-view v-if="loadRouter && $route.meta.keepAlive" :key="key" class="child-view"></router-view>
      </keep-alive>
    </template>
    <template v-else>
      <keep-alive>
        <router-view v-if="loadRouter && $route.meta.keepAlive" :key="key" class="child-view"></router-view>
      </keep-alive>
    </template>
    <router-view v-if="loadRouter && !$route.meta.keepAlive" class="child-view"></router-view>
  </div>
</template>

<script>
    import instantMessagingMixin from '@/mixins/modules/instantMessaging';

    // import loadView from './components/loadingView.vue'
    export default {
        name: 'app',
	    mixins: [instantMessagingMixin],
        data () {
            return {
                // LOADING: this.$store.state.refund.LOADING
                loadRouter: true,
            };
        },
        computed: {
            cachedViews () {
              return this.$store.state.refund.cachedViews
            },
            key () {
              return this.$route.path
            },
        },
        watch: {
          $route: {
            immediate: true,
            deep: true,
            handler: function(to, from) {
              const { name, meta: { keepAlive } } = to
              const cachedViewsArr = [
                '/refund/refundList',
                '/refund/statisticalAnalysis',
                '/refund/disposalProgressDetail',
              ] // 需要缓存的页面，只针对退货系统
              if (name && keepAlive ) {
                console.log('添加缓存');
                this.$store.commit('refund/ADD_CACHED_VIEW', to)
              }
                if (from && to.path === from.path) {
                      // 相同路由，不同参数，跳转时，重载页面
                      this.handleReload();
                  }
            },
          },
        },
        components: {
            // 'load-view': loadView
        },
        mounded () {
          this.preload()
        },
        methods: {
          // 网络异常页面图片预加载
          preload() {
            let imgUrl = './assets/refund/ic_wangluo@2x.png'
            let image = new Image()
            image.src = imgUrl
          },
            handleReload () {
                this.loadRouter = false;
                this.$nextTick(() => {
                    this.loadRouter = true;
                });
            }
            // 各页面设置title
            // setTitle (data) {
            //     window.yyn.invokeJSB(
            //         'setTitle', {
            //             title: data
            //         },
            //         cb => {
            //             console.log('设置title成功：', data);
            //         }
            //     )
            // }

        },
        // watch: {
        //     '$route' (to, from) {
        //       console.log(to);
        //       console.log(from);
        //         if (to.path === from.path) {
        //             // 相同路由，不同参数，跳转时，重载页面
        //             this.handleReload();
        //         }
                
        //     }
        // },
    };
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100%;
  /* 做个记录 */
  /* overflow: scroll; */
  /* -webkit-overflow-scrolling: touch; */
  position: absolute;
  top: 0;
}

.loadding {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999999;
}
body {
  margin: 0;
  box-sizing: border-box;
  .setConfirm {
    border-radius: 0;
  }
}
.van-picker__cancel {
  font-size: 14px !important;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(155, 155, 155, 1) !important;
}
.van-picker__confirm {
  font-size: 14px !important;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(54, 179, 116, 1) !important;
}
.van-picker-column__item {
  font-size: 14px !important;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(155, 155, 155, 1) !important;
}
.van-picker-column__item--selected {
  font-size: 20px !important;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500 !important;
  color: rgba(51, 51, 51, 1) !important;
}
</style>
